const services = [
  {
    title: "Buyer Representation",
    text: "Advisory for investors acquiring single-tenant NNN and Absolute NNN assets, including opportunity matching and negotiations.",
  },
  {
    title: "Financial and Lease Review",
    text: "Deal-level cap rate analysis, rent stream review, and lease-structure diligence to validate passive-income assumptions.",
  },
  {
    title: "1031 Exchange Support",
    text: "Replacement-property guidance for exchange buyers with timeline-aware sourcing and execution support.",
  },
  {
    title: "Disposition Advisory",
    text: "Strategy for owners planning exits, including pricing guidance, buyer targeting, and process management.",
  },
];

function Services() {
  return (
    <div className="section-wrap space-y-10 py-10 lg:py-14">
      <section className="grid gap-6 lg:grid-cols-2">
        <article className="premium-panel p-7 sm:p-10">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-obsidian-600">Services</p>
          <h1 className="mt-3 font-serif text-5xl leading-tight text-obsidian-950">
            Brokerage and Advisory Services for Net-Lease Investors
          </h1>
          <p className="mt-5 text-sm leading-7 text-obsidian-700">
            Built around the Cap Rate Experts model, our service stack supports investors
            from criteria planning through closing on high-quality NNN and Absolute NNN
            properties.
          </p>
        </article>

        <article className="overflow-hidden rounded-3xl border border-obsidian-200">
          <img
            src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1600&q=80"
            alt="Downtown office towers"
            className="h-full min-h-[340px] w-full object-cover"
          />
        </article>
      </section>

      <section className="grid gap-4 md:grid-cols-2">
        {services.map((service) => (
          <article key={service.title} className="premium-panel p-6">
            <h2 className="font-serif text-3xl text-obsidian-950">{service.title}</h2>
            <p className="mt-3 text-sm leading-7 text-obsidian-700">{service.text}</p>
          </article>
        ))}
      </section>

      <section className="premium-panel p-7 sm:p-10">
        <h2 className="font-serif text-4xl text-obsidian-950">Where This Helps Investors Most</h2>
        <div className="mt-5 grid gap-4 md:grid-cols-3">
          <article className="rounded-2xl border border-obsidian-200 bg-cream-50 p-5">
            <p className="text-sm font-semibold text-obsidian-900">Passive income acquisition</p>
            <p className="mt-2 text-sm leading-6 text-obsidian-700">Focus on lease duration, tenant stability, and return durability.</p>
          </article>
          <article className="rounded-2xl border border-obsidian-200 bg-cream-50 p-5">
            <p className="text-sm font-semibold text-obsidian-900">Portfolio diversification</p>
            <p className="mt-2 text-sm leading-6 text-obsidian-700">Access to multiple regions and tenant sectors across the United States.</p>
          </article>
          <article className="rounded-2xl border border-obsidian-200 bg-cream-50 p-5">
            <p className="text-sm font-semibold text-obsidian-900">1031 execution</p>
            <p className="mt-2 text-sm leading-6 text-obsidian-700">Time-sensitive replacement sourcing and diligence support.</p>
          </article>
        </div>
      </section>
    </div>
  );
}

export default Services;
